import React from "react";
import { ThreeCircles } from 'react-loader-spinner';

export default function ChartLoader() {
    let loader = (<div style={{ marginTop: "5%", height: "140px", display: "inline-block", position: "absolute",top:'50%'/*  right: '50%' */ }}><ThreeCircles
        height="60"
        width="60"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
        ariaLabel="three-circles-rotating"
        outerCircleColor="#3498db"
        innerCircleColor="#dec52d"
        middleCircleColor="#db213a"
    /></div>)
    return (
        <>
            {loader}
        </>
    );
}